<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      title: "種目管理",
      items: [
        {
          text: "Master",
          href: "/",
        },
        {
          text: "種目管理",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      name: "",
      player_count: null,
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: ["name", "player_count"],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "name",
          label: "種目名",
          sortable: true,
          tdClass: "minWidth200",
        },
        {
          key: "player_count",
          label: "人数",
          sortable: true,
          tdClass: "minWidth100",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
    };
  },
  mounted() {
    this.getUser("user");
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/events")
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/events/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.name = "";
      this.player_count = 1;
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.name = item.name;
      this.player_count = item.player_count;
    },
    // 確定
    submit() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("player_count", this.player_count);
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/events/update", formData, config)
        .then((res) => {
          this.loading = false;
          console.log(formData);
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      console.log(items);
      this.filterItems = items;
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>
<style>
.flex {
  display: flex;
}

.box {
  width: 60px;
  flex-shrink: 0;
}

.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.right {
  text-align: right;
}

.colorRed {
  color: red;
}

.table-hover tbody tr .colorRed {
  color: red;
}

.table-hover tbody tr:hover .colorRed {
  color: red;
}

.modal-mask {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span><button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button></span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add">
                    追加
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="種目名" label-cols-sm="3">
                      <ValidationProvider name="種目名" :rules="{
                        required: true,
                      }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" style="width: 200px" v-model="name"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="人数" label-cols-sm="3">
                      <ValidationProvider name="人数" :rules="{ required: true, regex: /^[1-2]$/ }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="number" style="width: 100px" v-model="player_count"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>